import { useEffect, useState } from "react"

import { FEATURE_FLAGS } from "../flags"
import { usePostHydrationFeatureFlagValue } from "./FeatureFlag"
import { useOrganizationFeatureFlagScope } from "./FeatureFlagsProvider"

// Keep legacy management reachable when PostHog is blocked, matching the workspace flag's deadline.
const RESOLUTION_TIMEOUT_MS = 2_000

export function useUserManagementFeatureFlag(): boolean | undefined {
  const value = usePostHydrationFeatureFlagValue(FEATURE_FLAGS.USER_MANAGEMENT)
  const { organizationId, isReady, hasError } =
    useOrganizationFeatureFlagScope()
  const [timedOutOrganization, setTimedOutOrganization] = useState<
    string | null
  >(null)
  const resolved = isReady && value !== undefined

  useEffect(() => {
    setTimedOutOrganization(null)
    if (!organizationId || resolved || hasError) {
      return
    }
    const timeout = window.setTimeout(() => {
      setTimedOutOrganization(organizationId)
    }, RESOLUTION_TIMEOUT_MS)
    return () => window.clearTimeout(timeout)
  }, [organizationId, resolved, hasError])

  if (!organizationId || hasError) {
    return false
  }
  if (resolved) {
    return value
  }
  return timedOutOrganization === organizationId ? false : undefined
}
